import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import React, { useEffect, useRef, useState } from "react";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import FormDatePicker from "../../components/formFields/FormDateField";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import moment from "moment";
import { RootState } from "../../app/store";
import {
  getKarigarListByProcess,
  getKarigarStock,
} from "../karigar/services/karigar.services";
import { LoadingPanel } from "../../components/layout/Loading";
import { IKarigarListByProcess } from "../karigar/karigarModel";
import { findAllActiveItem } from "../item/services/item.services";
import { createMina, getMinaById, updateMina } from "./services/mina.services";
import { findAllActiveProcess } from "../process/services/process.services";
import { clearMinaDetail } from "./minaSlice";
import MinaOrderItemArray from "./MinaOrderItemArray";
import { ErrorToast } from "../../components/toast/Toasts";
import { clearOrderDetail } from "../order/orderSlice";
import { findAllOrder } from "../order/services/order.services";
import { PRINT_ACCESS, PROCESS_ID } from "../../_contstants/common";
import { clearKarigarStock } from "../karigar/karigarSlice";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../_helper/helper";
import { FaEye } from "react-icons/fa";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const KarigarChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const karigar_id = formRenderProps.valueGetter("karigar_id");
  const fetchKarigarStock = async (karigar_id: number) => {
    await dispatch(getKarigarStock(karigar_id));
  };
  useEffect(() => {
    if (karigar_id) {
      fetchKarigarStock(karigar_id);
    }
  }, [karigar_id]);

  return null;
};
// import { FetchWeight } from "../palish/services/palish.services";

// interface FormChangeWatcherProps {
//   formRenderProps: FormRenderProps;
// }
// const ProcessChangeWatcher: React.FC<FormChangeWatcherProps> = ({
//   formRenderProps,
// }) => {
//   const karigar_id = formRenderProps.valueGetter("karigar_id");
//   const mina_issue_order = formRenderProps.valueGetter("mina_issue_order");
//   const dispatch = useAppDispatch();
//   const isFirstRun = useRef(true); // flag to skip first run
//   const fetchWeight = async (
//     previous_process_id: number,
//     order_id: number,
//     index: number
//   ) => {
//     const payload = {
//       process_id: previous_process_id,
//       order_id: order_id,
//       karigar_id: karigar_id,
//     };

//     const res = await dispatch(FetchWeight(payload));
//     if (res.meta.requestStatus === "fulfilled") {
//       formRenderProps.onChange(`mina_issue_order.${index}.weight`, {
//         value: res.payload.Data[0].gross_weight || 0,
//       });
//     } else {
//       formRenderProps.onChange(`mina_issue_order.${index}.weight`, {
//         value: 0,
//       });
//     }
//   };
//   useEffect(() => {
//     if (isFirstRun.current) {
//       // ⛔ skip the first run on mount (reload)
//       isFirstRun.current = false;
//       return;
//     }
//     if (mina_issue_order && mina_issue_order.length > 0) {
//       mina_issue_order.forEach((item: any, index: number) => {
//         if (item.previous_process_id && item.order_id) {
//           fetchWeight(item.previous_process_id, item.order_id, index);
//         }
//       });
//     }
//   }, [
//     mina_issue_order?.map((item: any) => item?.previous_process_id).join("-"),
//     mina_issue_order?.map((item: any) => item?.order_id).join("-"),
//   ]);

//   return null;
// };

const CreateMina: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const mina_issue_guid = location?.state?.mina_issue_guid;
  const loading = useAppSelector((state) => state.mina?.loading);
  const KarigarListByProcess = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  const karigarStock = useAppSelector((state) => state.karigar.KarigarStock);
  const MinaDetail = useAppSelector(
    (state: RootState) => state.mina.MinaDetail,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterOrder = useAppSelector((state) => state.order.FilterOrder);
  const isPrintAccess = checkAcessRights(
    "/" + location.pathname.split("/")[1],
    PRINT_ACCESS,
  );
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    dispatch(getKarigarListByProcess(PROCESS_ID.mina));
    dispatch(findAllActiveItem());
    dispatch(findAllActiveProcess());
    return () => {
      dispatch(clearMinaDetail());
      dispatch(clearOrderDetail());
      dispatch(clearKarigarStock());
    };
  }, []);

  useEffect(() => {
    const payload = {
      ...FilterOrder,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
      ProcessID: PROCESS_ID.mina,
    };
    dispatch(findAllOrder(payload));
  }, [currentPage, pageLimit]);

  useEffect(() => {
    if (mina_issue_guid) {
      dispatch(getMinaById(mina_issue_guid));
    }
  }, [mina_issue_guid]);
  useEffect(() => {
    setFormKey(formKey + 1);
  }, [MinaDetail]);

  const handleSubmit = async (values: any) => {
    if (values.mina_issue_order?.length === 0) {
      ErrorToast("At least One Order is Required !");
      return false;
    }
    const formData = {
      karigar_id: values.karigar_id ? +values.karigar_id : 0,
      issue_date: values.issue_date
        ? moment(values.issue_date).format("YYYY-MM-DD")
        : "",
      approx_delivery_date: values.approx_delivery_date
        ? moment(values.approx_delivery_date).format("YYYY-MM-DD")
        : "",
      mina_issue_order: values.mina_issue_order
        ? values.mina_issue_order.map((minaOrder: any) => {
            return {
              id: minaOrder.id ? minaOrder.id : 0,
              previous_process_id: minaOrder.previous_process_id
                ? +minaOrder.previous_process_id
                : null,
              order_id: minaOrder.order_id ? +minaOrder.order_id : null,
              item_id: minaOrder.item_id ? +minaOrder.item_id : null,
              item_description: minaOrder.item_description
                ? minaOrder.item_description
                : "",
              weight: minaOrder.weight ? minaOrder.weight : null,
              remarks: minaOrder.remarks ? minaOrder.remarks : "",
            };
          })
        : [],
    };
    if (mina_issue_guid) {
      const editPayload = {
        mina_issue_guid: mina_issue_guid,
        mina_issue_no: values.mina_issue_no,
        ...formData,
      };
      try {
        const response = await dispatch(updateMina(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/mina");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    } else {
      try {
        const response = await dispatch(createMina(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/mina");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };
  const handleFormClose = () => {
    navigate("/mina");
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={MinaDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <KarigarChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4>
                    {mina_issue_guid
                      ? "Update Mina Issue"
                      : "Create Mina Issue"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem colSpan={3}>
                  {mina_issue_guid ? (
                    <Typography.h5>
                      Mina No :{" "}
                      <span style={{ color: "green" }}>
                        {MinaDetail.mina_issue_no}
                      </span>
                    </Typography.h5>
                  ) : (
                    ""
                  )}
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="karigar_id"
                    label="Karigar Name"
                    placeholder="Select Karigar"
                    isAddNew={true}
                    addNewLink="karigar/create"
                    dispatcherFunction={getKarigarListByProcess}
                    dispatcherFunctionPayload={PROCESS_ID.mina}
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={KarigarListByProcess?.map(
                      (karigar: IKarigarListByProcess) => {
                        return {
                          value: karigar?.karigar_id,
                          label: `${karigar?.karigar_nick_name || karigar?.karigar_name}`,
                        };
                      },
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                  <Field
                    wrapperStyle={{ width: "100%" }}
                    name="issue_date"
                    label="Issue Date"
                    placeholder="day/month/year"
                    format={"dd/MM/yyyy"}
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                  <Field
                    wrapperStyle={{ width: "100%" }}
                    name="approx_delivery_date"
                    label="Approx Delivery Date"
                    format={"dd/MM/yyyy"}
                    placeholder="day/month/year"
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <div className="stock-container">
                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot amount-dot-${karigarStock.Amount_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Amount Balance
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value amount-value-${karigarStock.Amount_credit_debit}`}
                      >
                        {formatToIndianCurrencyWithoutSymbol(
                          karigarStock.amount || 0,
                        )}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.Amount_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>

                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot phine-dot-${karigarStock.phine_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Phine (gm) Stock
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value phine-value-${karigarStock.phine_credit_debit}`}
                      >
                        {formatWeight(karigarStock.phine)}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.phine_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayout cols={[{ width: "100%" }]}>
                <GridLayoutItem>
                  <Typography.h4>Mina Orders</Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={MinaOrderItemArray}
                    name="mina_issue_order"
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  {isPrintAccess && mina_issue_guid && (
                    <Button
                      type="button"
                      style={{ marginRight: 4 }}
                      fillMode={"solid"}
                      themeColor={"primary"}
                      onClick={() =>
                        window.open(`/minaissue/${mina_issue_guid}`, "_blank")
                      }
                    >
                      <FaEye style={{ fontSize: "18" }} /> View Report
                    </Button>
                  )}
                  <ButtonWithLoading
                    label={!mina_issue_guid ? "Create" : "Update"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                  <Button
                    type="button"
                    fillMode={"outline"}
                    themeColor={"primary"}
                    style={{ marginLeft: 4 }}
                    onClick={handleFormClose}
                  >
                    Cancel
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateMina;
